import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaBlockProps = {
  label: string;
  note?: string;
  tone?: 'light' | 'dark';
  id?: string;
  className?: string;
};
export function CtaBlock({
  label,
  note = 'Accesso immediato · Pagamento una tantum · Garanzia di 7 giorni',
  tone = 'light',
  id,
  className = ''
}: CtaBlockProps) {
  return <div className={`flex w-full flex-col items-center ${className}`} id={id} data-id="element-27" data-mp="1zpkghoue93dc">
      <a href={CHECKOUT_URL} className="group flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-brand px-5 py-4 text-center text-base font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#0b7d3d] transition-[transform,background-color] duration-150 ease-out hover:bg-brand-dark active:translate-y-[3px] active:shadow-[0_3px_0_0_#0b7d3d] sm:text-lg" data-id="element-28" data-mp="24p5loh05q7yi">
        <span data-id="element-29" data-mp="jc2r8fiyjuhj">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="jddvshk8969p" />
      </a>
      {note && <p className={`mt-3 max-w-sm text-center text-[12px] font-medium leading-relaxed sm:text-[13px] ${tone === 'dark' ? 'text-white/70' : 'text-navy/60'}`} data-id="element-31" data-mp="v5xcsk9y8vcg">
          {note}
        </p>}
    </div>;
}